import { 
  collection, 
  addDoc, 
  query, 
  where, 
  onSnapshot,
  orderBy,
  serverTimestamp,
  or
} from 'firebase/firestore';
import { db } from './firebase';

class MessageService {
  /**
   * Mesaj gönder
   */
  async sendMessage(senderId, receiverId, text, senderName, receiverName) {
    try {
      const messageData = {
        senderId,
        receiverId,
        text,
        senderName, // Listelemede kolaylık olsun diye ismide tutuyoruz
        receiverName,
        createdAt: new Date().toISOString(), // Sıralama için string ISO formatı (Firestore timestamp yerine tercih edilebilir)
        timestamp: serverTimestamp(), // Server tarafı kesin zamanı
        read: false
      };

      await addDoc(collection(db, 'messages'), messageData);
      return true;
    } catch (error) {
      console.error('Error sending message:', error);
      throw error;
    }
  }

  /**
   * Kullanıcının tüm mesajlarını dinle (Gelen ve Giden)
   * Not: Firestore'da 'OR' sorgusu karmaşık indeks gerektirebilir,
   * bu yüzden basitlik için iki ayrı sorgu (gelen/giden) yapıp birleştireceğiz
   * veya Firestore Query Composite Index varsa 'or' kullanabiliriz.
   * Şimdilik güvenli yol olan iki listener'ı kullanıyoruz.
   */
  subscribeToAllMessages(userId, callback) {
    const messages = { sent: [], received: [] };

    // 1. Gönderilen mesajları dinle
    const qSent = query(
      collection(db, 'messages'),
      where('senderId', '==', userId),
      orderBy('createdAt', 'desc') // En yeni en üstte
    );

    const unsubscribeSent = onSnapshot(qSent, (snapshot) => {
      messages.sent = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      this._mergeAndNotify(messages, callback);
    });

    // 2. Alınan mesajları dinle
    const qReceived = query(
      collection(db, 'messages'),
      where('receiverId', '==', userId),
      orderBy('createdAt', 'desc')
    );

    const unsubscribeReceived = onSnapshot(qReceived, (snapshot) => {
      messages.received = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      this._mergeAndNotify(messages, callback);
    });

    // Temizleme fonksiyonu döndür
    return () => {
      unsubscribeSent();
      unsubscribeReceived();
    };
  }

  // Yardımcı: Mesajları birleştir, tarihe göre sırala ve callback'i çağır
  _mergeAndNotify(messages, callback) {
    const allMessages = [...messages.sent, ...messages.received];
    // Tarihe göre yeniden sırala (en yeni en altta olacak şekilde sohbet akışı için, 
    // veya en yeni en üstte liste için. UI tarafında düzenleyeceğiz)
    allMessages.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    callback(allMessages);
  }
}

export default new MessageService();